import { SuccessResult } from "./SuccessResult";

export const UpgradeSuccessResult: React.FC = () => {
  return (
    <SuccessResult
      title="Your upgrade is successful"
      text="Thank you for your purchase. Your new features are now active."
    />
  );
};
